import React from 'react';
import styles from './course-offer.module.css'
import Link from "gatsby-link"
import utils from '../../utils/utils'
import { Button, Card, Image, Header, Segment, Tab } from 'semantic-ui-react'
import { slash } from '../../utils/utils'

const tabContent = (seq, cards) => {
  const from = (seq * 10) + 0;
  const to = (seq * 10) + 10;
  const slices = cards.slice(from, to);
  return { menuItem: /*`${from+1}-${to}`*/ `${seq+1}`, render: () => (<Tab.Pane>
    <Card.Group stackable={false}>{slices}</Card.Group>
  </Tab.Pane>) }
}

const OfferHeader = ({category, totalCourse, totalUni}) => {
  const desc = `${totalCourse} ${category} courses offer by ${totalUni} university`;
  return <Segment><Header
    as='h5'
    icon='find'
    content={desc}
  /></Segment>
}

const UniversityCard = ({header, subheader, description, url}) => {
  //TODO
  return <Card fluid >
    <Card.Content>
      <Link to={url}>
      <Image floated='right' size='tiny' src='https://dummyimage.com/150x150/2ec72e/0011ff' />
      <Card.Header>{header}</Card.Header>
      <Card.Meta>{subheader}</Card.Meta>
      <Card.Description>{description}</Card.Description>
      </Link>
    </Card.Content>
    <a style={{display:'none'}} href={slash(url)}>{header}</a>
  </Card>
}

const CourseOffer = ({offers, course, category}) => {
    const totalUni = offers.length;
    const totalCourse = offers.reduce((acc, x, y) => { return acc + x["uni_"+y].length; }, 0);
    const tabs = Math.ceil(totalUni / 10);
    const allcards = offers.map((groupResults, key) => {
      const results = groupResults["uni_"+key];
      const courseOfferCount = results.length + " Courses Available";
      const { university, category, uslug } = results[0];
      //const url = "/" + category + "/" + uslug;
      const url = utils.universityCategoryUrl(category, uslug);
      const props = {
        key,
        header: university,
        subheader: courseOfferCount,
        url
      }
      return <UniversityCard {...props} />
    });
    const tabsArray = Array.from(Array(tabs).keys()).filter(x => (x <= 5));
    const panes = tabsArray.map(x => {
      return tabContent(x, allcards);
    });
    if(panes.length > 0) {
      return <div>
        <OfferHeader category={category} totalCourse={totalCourse} totalUni={totalUni} />
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
    }
    //TODO: render meaningful message when no course offer
    return <div />
}

export default CourseOffer;



// WEBPACK FOOTER //
// ./src/components/CourseOffer/index.js